import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Input, Typography, Checkbox, CircularProgress } from '@mui/material';
import { green, grey, red } from '@mui/material/colors';

import { getDiaSemana } from '../../../utils/crm/getDiaSemana';
import { listCorretores, ordenarOperadores, updateCorretor } from '../../../controllers/crm/escalaController';
import { escalaStatus, operadorStatus } from '../../../constants/crm';
import { getDistribuicao } from '../../../utils/crm/getDistribuicao';
import dayjs from 'dayjs';


export function HabilitarCorretores({ openCorretores, setOpenCorretores, escala, listEscalas, setSnackbar, idusuario }) {

  const [corretores, setCorretores] = useState([])
  const [filtered, setFiltered] = useState(corretores)
  const [loading, setLoading] = useState(false)
  const [ordenada, setOrdenada] = useState(true)
  const [openHistorico, setOpenHistorico] = useState(false)

  const hoje = dayjs(dayjs().format('YYYY-MM-DD')).toISOString()

  // Pequisar corretores
  function pesquisarNome(event) {
    const filtro = corretores.filter(corretor => corretor.nome.toLowerCase().includes(event.target.value.toLowerCase()))
    setFiltered(filtro)
  }

  // Adicionar Check para todos os corretores
  function addCheck(_corretores) {
    _corretores.forEach(function (c, index) {
      if (c.status === operadorStatus.Disponivel) c.checked = true
      else c.checked = false
    })
    return _corretores
  }

  // Carregar Corretores da escala da camada de controle
  async function carregarCorretores(idescala, idconta) {
    setLoading(true)
    setCorretores([])
    setFiltered([])
    try {
      const where = { idescala: idescala, idconta: idconta }
      const response = await listCorretores(where)

      if (response.status === 200) {
        if (response.data.length > 0) {
          const _corretores = addCheck(response.data)
          setCorretores(_corretores)
          setFiltered(_corretores)
        }
        else {
          // setSnackbar({ open: true, message: 'Não há corretores cadastrados para esta escala', severity: 'warning' })
          setCorretores([])
          setFiltered([])
        }
        setLoading(false)
      }
      else {
        setSnackbar({ open: true, message: 'Erro ao carregar corretores', severity: 'error' })
        setLoading(false)
      }
    }
    catch (e) {
      setSnackbar({ open: true, message: 'Erro ao carregar corretores', severity: 'error' })
      setLoading(false)
    }
  }

  // Atualizar status do corretor
  async function handleCheck(corretor, e) {
    setLoading(true)
    // Atualiza o status do corretor
    const status = e.target.checked ? operadorStatus.Disponivel : operadorStatus.Indisponivel
    try {
      const response = await updateCorretor({
        idusuario: idusuario,
        idescala: escala.idescala,
        historico: escala.historico,
        nome: corretor.nome,
        idoperescala: corretor.idoperescala,
        ordem: corretor.ordem,
        status: status,
        version: corretor.version,
        versionescala: escala.version
      })
      // console.log('reponse',response)
      if (response.status === 200) {
        corretor.version = response.data.version
        escala.historico = response.data.historico
        escala.version = response.data.versionescala
        await carregarCorretores(escala.idescala, escala.idconta)
      }
      else {
        setSnackbar({ open: true, message: 'Erro ao atualizar status do corretor', severity: 'error' })
      }
    }
    catch (erro) {
      setOpenCorretores(false)
      if (erro.response.data.code === 'P2025') {
        setSnackbar({ open: true, message: 'Falha de acesso concorrente, realize novamente a operação!', severity: 'error' })
        listEscalas()
      }
      else
        setSnackbar({ open: true, message: 'Erro ao atualizar status do corretor', severity: 'error' })
    }
    finally {
      setLoading(false)
    }
  }

  // Ordenar os corretores
  async function ordenarCorretores(_escala) {
    setLoading(true)
    const where = {
      idescala: _escala.idescala,
      tpdistribuicao: _escala.tpdistribuicao,
      status: _escala.status,
      idconta: _escala.idconta,
      dia: dayjs(_escala.diamesano).toISOString(),
      inout: _escala.inout,
      idusuario: idusuario,
      historico: _escala.historico,
      versionescala: _escala.version
    }
    if (corretores.length > 0) {
      try {
        const response = await ordenarOperadores(where)
        // console.log(response)
        if (response.status === 200) {
          if (response.data.operadores.length > 0) {
            // Atualiza o status da escala
            escala.status = escalaStatus.Ordenada
            // Atualiza o histórico da escala
            escala.historico = response.data.historico
            // Atualiza a versão da escala
            escala.version = response.data.versionescala
            // Carrega os corretores
            await carregarCorretores(escala.idescala, escala.idconta)
            setOrdenada(true)
            setSnackbar({ open: true, message: 'Corretores ordenados com sucesso', severity: 'success' })
          }
          else {
            setSnackbar({ open: true, message: 'Não foram encontrados participantes para ordenar!', severity: 'warning' })
          }
        }
        else if (response.status === 201) {
          if (corretores.length > 0) {
            setOpenCorretores(false)
            setSnackbar({ open: true, message: 'Acesso Concorrente', severity: 'warning' })
            listEscalas()
          }
        }
        else if (response.status === 202) {
          setSnackbar({ open: true, message: 'Operadores já ordenados', severity: 'warning' })
          listEscalas()
        }
        else {
          setSnackbar({ open: true, message: 'Erro ao ordenar corretores', severity: 'error' })
        }
      }
      catch (erro) {
        setSnackbar({ open: true, message: 'Erro ao ordenar corretores', severity: 'error' })
      }
      finally {
        setLoading(false)
      }
    }
    else {
      setSnackbar({ open: true, message: 'Não há corretores cadastrados para esta escala', severity: 'warning' })
      setLoading(false)
    }
  }

  // Dialog para exibir histórico
  const HistoricoDialog = () => {
    const formatarHistorico = (historico) => {
      if (!historico) return 'Nenhum histórico disponível';
      
      return historico
        .split('#')
        .filter(linha => linha.trim() !== '')
        .map((linha, index) => (
          <Typography 
            key={index}
            variant="body2" 
            component="div"
            sx={{
              fontFamily: 'monospace',
              fontSize: '12px',
              lineHeight: 1.4,
              padding: '2px 0',
              borderBottom: index % 2 === 0 ? '1px solid #f0f0f0' : 'none'
            }}
          >
            {linha.trim()}
          </Typography>
        ));
    };

    return (
      <Dialog
        open={openHistorico}
        onClose={() => setOpenHistorico(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            m: 0,
            maxHeight: '80vh',
            width: '80vw'
          }
        }}
      >
        <DialogTitle>
          <Typography variant="h5" component="div">
            Histórico de Movimentos
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <div
            style={{
              maxHeight: '400px',
              overflow: 'auto',
              padding: '8px'
            }}
          >
            {formatarHistorico(escala.historico)}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => setOpenHistorico(false)}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    if (escala.idescala) {
      if (escala.status !== escalaStatus.Prevista) {
        setOrdenada(true)
      }
      else setOrdenada(false)
      carregarCorretores(escala.idescala, escala.idconta)
    }
  }, [])


  return (
    <>
      <Dialog
        open={openCorretores}
        fullScreen={window.innerWidth < 600}
      >
        <DialogTitle >
          <Typography variant="h4" component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
            {`ON-LINE ( ${getDiaSemana(escala.diamesano).toLocaleUpperCase()} - ${new Date(escala.diamesano).toLocaleDateString()} )`}
          </Typography>
          <Typography variant="h5" component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
            {`Distribuição: ${getDistribuicao(escala.tpdistribuicao)} - ${dayjs(escala.hrinicial).format('HH:mm')} / ${dayjs(escala.hrfinal).format('HH:mm')}`}
          </Typography>

        </DialogTitle>
        <DialogContent dividers>
          <Grid container 
          // height={'450px'} 
          >
            {(loading) && ((
              <div style={{ position: 'fixed', top: '50vh', left: '50vw' }}>
                <CircularProgress />
              </div>
            ))}
            <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
              <Grid item xs={6} >
                <Input id='pesquisar' fullWidth onChange={(e) => pesquisarNome(e)} placeholder="Pesquisar" />
              </Grid>

              <Grid item xs={3} textAlign={'end'}>
                <Button variant="contained" color="primary" size="small" sx={{ width: '100px' }}
                  onClick={() => ordenarCorretores(escala)}
                  disabled={loading || ordenada || (escala.diamesano < hoje)}
                >
                  Ordenar
                </Button>
              </Grid>
            </Grid>
            <Grid container mt={1} height={'30px'} >
              <Grid item
                xs={1}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ backgroundColor: grey[300] }}
              // p={0.5}
              >
                <Typography variant="body1" fontSize={12} component="div">
                  Ord
                </Typography>
              </Grid>
              <Grid item
                xs={7}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ backgroundColor: grey[400] }}
              >
                <Typography variant="body1" fontSize={12} component="div">
                  Nome
                </Typography>
              </Grid>
              <Grid item
                xs={2}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ backgroundColor: grey[300] }}
              >
                <Typography variant="body1" fontSize={12} component="div">
                  Horário
                </Typography>
              </Grid>
              <Grid item
                xs={2}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                sx={{ backgroundColor: grey[400] }}
              >
                <Typography variant="body1" fontSize={12} component="div">
                  Ativo
                </Typography>
              </Grid>
            </Grid>
            <Grid container overflow={'auto'}
              height={'250px'}
              display={'flex'}
              alignContent={'flex-start'}
              direction={'row'}
            >
              {filtered.map((operador) => (
                <Grid container key={operador.idoperador} wrap="nowrap" mt={0.5}
                  sx={{ backgroundColor: operador.status === operadorStatus.Disponivel ? green[200] : red[100], minWidth: 0 }}
                >
                  <Grid
                    item xs={1}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    <Typography variant="body1" fontSize={12} component="div" noWrap>
                      {operador.ordem}
                    </Typography>
                  </Grid>
                  <Grid
                    item xs={7}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'flex-start'}
                    px={'5px'}
                  // sx={{ backgroundColor: operador.status === operadorStatus.Disponivel ? green[400] : red[400], minWidth: 0 }}
                  >
                    <Typography variant="body1" fontSize={12} component="div" noWrap title={operador.nome}>
                      {operador.nome}
                    </Typography>
                  </Grid>
                  <Grid
                    item xs={2}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    px={'2px'}
                  // sx={{ backgroundColor: operador.status === operadorStatus.Disponivel ? green[400] : red[400], minWidth: 0 }}
                  >
                    <Typography variant="body1" fontSize={12} component="div" noWrap>
                      {dayjs(operador.hrinicial).format('HH:mm') + '/' + dayjs(operador.hrfinal).format('HH:mm')}
                    </Typography>
                  </Grid>
                  <Grid
                    item xs={2}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    <Checkbox id={operador.idoperador}
                      defaultChecked={operador.checked}
                      onChange={(e) => handleCheck(operador, e)}
                      disabled={loading || (escala.diamesano < hoje)}
                      size="small"
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item textAlign={'center'} mt={1}>
              <Button variant="contained" color="info" size="small" sx={{ width: '100px' }}
                onClick={() => setOpenHistorico(true)}
              >
                Movimentos
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container display={'flex'} justifyContent={'flex-end'}>
            <Button variant="contained" color="primary" size="small"
              onClick={() => setOpenCorretores(false)}
            >
              Fechar
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* Dialog do Histórico */}
      <HistoricoDialog />
    </>
  );
}